import { getRoomUrlFromSlug, getSlugFromRoomUrl } from './config/roomMapping';

/**
 * Extrai a URL da sala da URL da página.
 * Tenta buscar pelo slug no Supabase primeiro, depois pelo query param.
 *
 * @returns {Promise<string|null>} URL da sala ou null se não encontrada
 */
export async function roomUrlFromPageUrl() {
  const { pathname, search } = window.location;
  const slug = pathname.replace(/^\/+|\/+$/g, '');

  if (slug) {
    const roomUrl = await getRoomUrlFromSlug(slug);
    if (roomUrl) {
      return roomUrl;
    }
  }

  const match = search.match(/roomUrl=([^&]+)/i);
  return match && match[1] ? decodeURIComponent(match[1]) : null;
}

/**
 * Gera a URL da página baseada na URL da sala.
 * Tenta buscar o slug no Supabase primeiro.
 * Se já houver um slug na URL atual e ele corresponder ao roomUrl, mantém apenas o slug.
 *
 * @param {string} roomUrl - URL da sala Daily
 * @returns {Promise<string>} URL da página
 */
export async function pageUrlFromRoomUrl(roomUrl) {
  if (!roomUrl) {
    const { origin } = window.location;
    const base = `${origin}${window.location.pathname.split('?')[0]}`;
    return base;
  }

  const { origin, pathname } = window.location;
  const currentSlug = pathname.replace(/^\/+|\/+$/g, '');

  // Se já tem um slug na URL, verifica se ele corresponde ao roomUrl
  if (currentSlug) {
    const currentRoomUrl = await getRoomUrlFromSlug(currentSlug);
    if (currentRoomUrl === roomUrl) {
      // Slug já está correto, retorna apenas o slug sem query params
      return `${origin}/${currentSlug}`;
    }
  }

  // Tenta buscar o slug no Supabase
  const slug = await getSlugFromRoomUrl(roomUrl);
  if (slug) {
    return `${origin}/${slug}`;
  }

  // Se não encontrou slug, usa query param (mas só se não houver slug na URL atual)
  const base = `${origin}${pathname.split('?')[0]}`;
  if (currentSlug) {
    // Se já tem slug mas não corresponde, mantém o slug e não adiciona query param
    return `${origin}/${currentSlug}`;
  }
  return `${base}?roomUrl=${encodeURIComponent(roomUrl)}`;
}

// Extrai apenas o ID do path final da roomUrl
export function roomIdFromRoomUrl(roomUrl) {
  if (!roomUrl) return null;
  try {
    const url = new URL(roomUrl);
    const parts = url.pathname.split('/').filter(Boolean);
    return parts[parts.length - 1] || null;
  } catch {
    return null;
  }
}

export function getTokenFromUrl(url) {
  if (!url || typeof url !== 'string') return "";

  const parts = url.split('t=');
  if (parts.length < 2) return "";

  const tokenPart = parts[1].split('&')[0]; // caso venha com outros parâmetros depois
  return tokenPart || null;
}
